import { buildCalendarLinks, downloadIcsFile } from "../utils/calendar";

function AddToCalendarButtons({ lab, variant = "default" }) {
  if (!lab) {
    return null;
  }

  const { googleUrl, outlookUrl } = buildCalendarLinks(lab);
  const isCompact = variant === "compact";
  const containerClassName = `calendar-buttons ${
    isCompact ? "calendar-buttons-compact" : ""
  }`;
  const buttonClassName = `btn btn-outline ${isCompact ? "calendar-option-btn" : ""}`;

  return (
    <div className={containerClassName.trim()} aria-label="Add to calendar actions">
      <a
        className={buttonClassName.trim()}
        href={googleUrl}
        target="_blank"
        rel="noreferrer"
      >
        {isCompact ? "Google" : "Google Calendar"}
      </a>
      <a
        className={buttonClassName.trim()}
        href={outlookUrl}
        target="_blank"
        rel="noreferrer"
      >
        Outlook
      </a>
      <button
        className={buttonClassName.trim()}
        type="button"
        onClick={() => downloadIcsFile(lab)}
      >
        {isCompact ? "Apple / ICS" : "Apple / .ics"}
      </button>
    </div>
  );
}

export default AddToCalendarButtons;
